export default function LogoHeader() {
  return (
    <div className="xl:justify-self-start cursor-pointer">
      <a href="/dashboard">
        <img src={process.env.PUBLIC_URL + "/logo.svg"} alt="Logo" className="h-10" /> </a>
    </div>
  );
}
